export default "__VITE_ASSET__CPPagsyT__"